import React from 'react';
import PropTypes from 'prop-types';
import ProductImage from '../ProductImage';
import { Box } from '@material-ui/core';
import MarketUpperImage from '../../../../common/MarketUpperImage';

const ProductImageMobile = ({ ...props }) => {
  const { isMkp, src, purchaseState, sku } = props;
  return (
    <Box>
      <MarketUpperImage isMkp={isMkp}>
        <ProductImage
          src={src}
          mobile={true}
          purchaseState={purchaseState}
          sku={sku}
        />
      </MarketUpperImage>
    </Box>
  );
};

ProductImageMobile.propTypes = {
  isMkp: PropTypes.bool,
  src: PropTypes.string,
  purchaseState: PropTypes.string,
  sku: PropTypes.string,
};

export default ProductImageMobile;
